<div class="pt-2">
  <div class="col-12 d-flex flex-nowrap">
    <h2>Verify Uploaded {{location.displayOptions.labels.reservation_plural | titlecase }} ({{parties.length}})</h2>
  </div>
  <table class="table table-striped tr-table">
    <thead>
      <tr>
        <th>Selected</th>
        <th>Time</th>
        <th>{{location.displayOptions.labels.customer | titlecase}}</th>
        <th>Size</th>
        <th class="span3">Notes</th>
        <th *ngFor="let field of customFieldNames" class="span3" [innerText]="field"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let party of parties; index as index; trackBy: trackBy" class="animate-hide" [hidden]="party.isHidden">
        <td><input type="checkbox" [formControl]="selection.controls[index]" (change)="changeSelection()" /></td>
        <td>{{party.quoted_time | trDateFormat:'MMM D, y': location.timezone}} {{party.quoted_time | trDateFormat:'hh:mm a': location.timezone }}</td>
        <td>{{party.name}}<br />{{party.phone | trTel}}</td>
        <td>{{party.size}}</td>
        <td>{{party.note}}</td>
        <td *ngFor="let field of customFieldNames" class="span3" [innerText]="party.customFields[nameIdMap[field]] === undefined ? '' : party.customFields[nameIdMap[field]]"></td>
      </tr>
    </tbody>
  </table>
  <div class="d-flex justify-content-center">
    <input
      id="column-header"
      type="checkbox"
      class="form-control check-input-import"
      [checked]="sendConfirmation"
      (click)="confirmSendSms($event)"
    />
    <label class="col-form-label pl-1" for="column-header">Send {{ location.displayOptions?.labels?.reservation || 'reservation' | titlecase }} Confirmation SMS to Selected</label>
  </div>
  <div class="d-flex justify-content-center">
    <button
      type="submit"
      class="btn btn-info ml-3"
      (click)="save();submitting = true;"
      [disabled]="disableSubmit || submitting"
      angularticsCategory="reservations"
      angulartics2On="click"
      angularticsAction="Save Uploaded CSV"
    >Save Selected</button>
    <button
      type="button"
      class="btn btn-danger ml-3"
      (click)="cancel()"
      [disabled]="submitting"
      angularticsCategory="reservations"
      angulartics2On="click"
      angularticsAction="Cancel Uploaded CSV"
    >Cancel</button>
  </div>
</div>
